var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.certification.time))]),_c('h3',[_vm._v(_vm._s(_vm.certification.title))]),_c('p',[_vm._v(" "+_vm._s(_vm.certification.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }